import { FC, useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import HorizontalPadding from "../components/HorizontalPadding";
import label_10x6 from "../assets/Label10X6IconV2.png";
import label_10x10 from "../assets/Label10X10IconV2.png";
import { PrimaryButton } from "../components/Buttons";
import WarningModal from "../components/WarningModal";
import { GetSettingsLabels, UpdateSettingsLabels } from "../services";
import { setUserLocation } from "../store/slices";
import { ResponseInterface } from "../interfaces";

const LabelSettings: FC = () => {
  const userBu = useAppSelector((state) => state.user.businessUnit);
  const user = useAppSelector((state) => state.user);
  const [typeLabel, setTypeLabel] = useState(userBu?.labelFormat);
  const [showSaveChangeModal, setShowSaveChangeModal] = useState(false);
  const [loadLabelConfig, setLoadLabelConfig] = useState(false);
  const dispatch = useAppDispatch();
  
  /*
  useEffect(() => {
    GetSettingsLabels(userBu?.code ?? "")
      .then((labelFormat) => {
        setTypeLabel(labelFormat);
        setLoadLabelConfig(false);
      });
  }, []);
  */

  const handleTypeLabelChange = (newTypeLabel: number) => {
    setTypeLabel(newTypeLabel);
  }

  const handleSaveChanges = async () => {
    let result: ResponseInterface<boolean> = await UpdateSettingsLabels(userBu?.code ?? "", typeLabel ?? 0, user.user?.userLogin ?? "");
    if(!result.didError) {
      if (userBu) {
        const updatedBU = {
          ...userBu,
          labelFormat: typeLabel // O el nombre del campo que agregaste
        };
        dispatch(setUserLocation(updatedBU));
      }
    }
    setShowSaveChangeModal(false);
  }

  return (

    <main className="lg:pl-72">
      <div className="py-6 sm:px-6 lg:px-8 bg-white relative flex items-center justify-between h-32 mb-12">
        <div>
          <header className="ml-4 text-2xl font-bold text-gray-700 ">
            Configuración de Etiqueta
          </header>
        </div>
      </div>

      {/* Proof of Payment Warning Modal */}
      <WarningModal
        openModal={showSaveChangeModal}
        setOpenModal={setShowSaveChangeModal}
        message="¿Está seguro que desea cambiar el tamaño de la etiqueta a imprimir? Este cambio afectará a todos los usuarios de la tienda."
        onPrimaryButton={() => handleSaveChanges()}
        showSecondaryButton={true}
        onSecondaryButton={() => setShowSaveChangeModal(false)}
      />

      <HorizontalPadding>
        <div>

          <div className="flex flex-1 flex-col bg-white rounded-lg border p-2 pb-6">
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-gray-700 px-6 py-4">
                Tienda {userBu?.code}
              </span>
              <span className="text-sm font-semibold text-gray-700 hidden sm:inline px-6 py-4">
                Tamaño de la etiqueta
              </span>
            </div>
            {!loadLabelConfig &&
              (
                <>

                  <div className="flex flex-1 flex-col items-center sm:flex-row sm:gap-3 px-6 py-4">

                    <div className="flex gap-4">
                      <div
                        className={`cursor-pointer border-2 rounded-lg p-4 flex flex-col items-center gap-2 transition-all ${typeLabel === 0 ? "border-indigo-600 bg-blue-50" : "border-gray-200 hover:border-gray-300"}`}
                        onClick={() => handleTypeLabelChange(0)}
                      >
                        <input
                          className="hidden"
                          type="radio"
                          id="oldLabel"
                          name="labelType"
                          value="0"
                          checked={typeLabel === 0}
                          onChange={() => handleTypeLabelChange(0)}
                        />
                        <img
                          src={label_10x6}
                          alt="10 x 6 cm"
                          className="w-32 h-auto object-contain"
                        />
                        <label htmlFor="oldLabel" className="cursor-pointer font-medium text-gray-700 mt-auto">10 x 6 cm</label>
                      </div>

                      <div
                        className={`cursor-pointer border-2 rounded-lg p-4 flex flex-col items-center gap-2 transition-all ${typeLabel === 1 ? "border-indigo-600 bg-blue-50" : "border-gray-200 hover:border-gray-300"}`}
                        onClick={() => handleTypeLabelChange(1)}
                      >
                        <input
                          className="hidden"
                          type="radio"
                          id="newLabel"
                          name="labelType"
                          value="1"
                          checked={typeLabel === 1}
                          onChange={() => handleTypeLabelChange(1)}
                        />
                        <img
                          src={label_10x10}
                          alt="10 x 10 cm"
                          className="w-32 h-auto object-contain"
                        />
                        <label htmlFor="newLabel" className="cursor-pointer font-medium text-gray-700 mt-auto">10 x 10 cm</label>
                      </div>

                    </div>
                  </div>
                  <div className="flex px-6 py-4">
                    <PrimaryButton
                      className="w-full sm:w-48"
                      disabled={typeLabel === userBu?.labelFormat}
                      onClick={() => setShowSaveChangeModal(true)}
                    >
                      Guardar
                    </PrimaryButton>
                  </div>
                </>
              )
            }
          </div>
        </div>
      </HorizontalPadding>
    </main>
  );
};

export default LabelSettings;
